// AppInsights.js
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import UAParser from "ua-parser-js";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import store from "./reducers/store";

export const getBrowserAndOsInfo = () => {
	const parser = new UAParser();
	const browserInfo = parser.getBrowser();
	const osInfo = parser.getOS();

	return {
		browserName: browserInfo.name,
		browserVersion: browserInfo.version,
		osName: osInfo.name,
		osVersion: osInfo.version,
		platform: navigator.platform, // This will give platform information (e.g., "Win32", "MacIntel")
		userAgent: navigator.userAgent, // Full user-agent string
	};
};

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();
const appInsights =
	process.env.REACT_APP_INSTRUMENTATION_KEY !== undefined &&
	process.env.REACT_APP_INSTRUMENTATION_KEY &&
	process.env.REACT_APP_INSTRUMENTATION_KEY !== ""
		? new ApplicationInsights({
				config: {
					instrumentationKey:
						process.env.REACT_APP_INSTRUMENTATION_KEY ===
							undefined ||
						process.env.REACT_APP_INSTRUMENTATION_KEY === ""
							? ""
							: process.env.REACT_APP_INSTRUMENTATION_KEY,
					enableAutoRouteTracking: true,
					extensions: [reactPlugin],
					extensionConfig: {
						[reactPlugin.identifier]: {
							history: browserHistory,
						},
					},
				},
		  })
		: null;

if (appInsights !== null) {
	appInsights.loadAppInsights();
	// Global error handling for uncaught exceptions
	window.onerror = function (message, source, lineno, colno, error) {
		const reduxState = store.getState();
		appInsights.trackException({
			exception: error || new Error(message),
			severityLevel: 3, // Error severity
			properties: {
				sourceFile: source,
				lineNumber: lineno,
				columnNumber: colno,
				reduxState: JSON.stringify(reduxState),
				browserOs: getBrowserAndOsInfo(),
			},
		});
		return false; // Return false to allow the browser to also log the error
	};
}

export { reactPlugin, appInsights };
